import React from "react";
import Helmet from "react-helmet";
import { useParams } from "react-router-dom";
import NotFound from "../../common/NotFound";
import LiveHeader from "../common/LiveHeader";
import { Container } from "./styled/live-not-found";

function LiveNotFound() {
  const { guid } = useParams();

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <LiveHeader />
      <Container>
        <NotFound link={`/live/${guid}`} />
      </Container>
    </>
  );
}

export default LiveNotFound;
